import { useLinkHandler } from 'hook/event.hook';
import {
  buildAttributes,
  CLICK,
} from 'partial/OfferManager/modules/staticModule';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import { potentialPaymentHistoryByGrade } from 'types/creditReport.constants';
import { getHighestLimitHelper } from 'helpers/offer.helpers';
import { REDUCE_CREDIT_USAGE_WITH_LIMIT_INCREASE } from 'partial/OfferManager/module.constants';

export const useGoalReduceCreditUsageWithLimitIncrease = props => {
  const totalDebt = props?.creditInfo?.debtAnalysis?.creditCardDebt?.totalDebt;
  const creditLimit =
    props?.creditInfo?.creditScoreAnalysis?.creditUsage?.limit;
  const debt = props?.creditInfo?.creditScoreAnalysis?.creditUsage?.debt;
  const creditUsage = Math.round((debt / creditLimit) * 100);
  const offerMaxLimit = getHighestLimitHelper(props?.offers);
  let potentialLimit = offerMaxLimit + creditLimit;

  const potentialCreditUsage = Math.round((totalDebt / creditLimit) * 100);
  const { config } = props;
  const finalConfig = config
    ? config
    : { disclaimers: { potentialScoreChangeToolTip: {} } };
  const { disclaimers } = finalConfig;
  const { potentialScoreChangeToolTip } = disclaimers;
  const onLinkClickCallback = useLinkHandler(props?.eventHandler);

  const onClickApply = () => {
    props.eventHandler(
      CLICK,
      buildAttributes(props, {
        'Click Type': 'Apply',
      }),
    );
  };
  const atr = getViewModuleTrackingAttributes(
    REDUCE_CREDIT_USAGE_WITH_LIMIT_INCREASE,
    props?.modulePosition,
  );

  const creditUsageGrade =
    props?.creditInfo?.creditScoreAnalysis?.creditUsage?.grade;

  const seenPixel = useSeenModulePixel(atr);

  return {
    offerMaxLimit,
    onClickApply,
    creditUsage,
    creditLimit,
    potentialCreditUsage,
    potentialLimit,
    potentialScoreChangeToolTip,
    onLinkClickCallback,
    seenPixel,
    creditUsageGrade,
    potentialCreditUsageGrade: potentialPaymentHistoryByGrade[creditUsageGrade],
  };
};
